import React, { useEffect, useRef, useState } from 'react';
import { Slider } from '@/components/ReactSlickCarousel';
import { MEDIA_TYPES } from 'src/utils/constants';
import { MediaContainer } from 'src/components/ProductMediaRenderer/MediaContainer';

const QuickViewCarouselMobile = (props) => {
  const { imageArray } = props;
  const sliderRef = useRef();
  const [activeSlide, setActiveSlide] = useState(0);
  const [initialSlide, setInitialSlide] = useState(0);

  useEffect(() => {
    setInitialSlide(0);
    sliderRef?.current?.slickGoTo(0);
    stopVideo();
  }, [props.activeVariant]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    activeSlide: initialSlide,
    afterChange: (current) => setActiveSlide(current),
    beforeChange: (current) => {
      if (imageArray[current]?.media_type === MEDIA_TYPES.YOUTUBE_VIDEO) {
        stopVideo();
      }
    },
  };

  if (!imageArray || imageArray.length === 0) return null;

  const stopVideo = () => {
    const productVedioIframe = document.querySelector('.mobileQV-image-slider iframe');
    productVedioIframe && (productVedioIframe.src = productVedioIframe.src);
  };

  /**
   * slider prev button
   * click handler function
   */
  const onPrevClick = () => {
    if (sliderRef?.current?.slickPrev) {
      sliderRef?.current?.slickPrev();
    }
  };

  /**
   * slider next button
   * click handler function
   */
  const onNextClick = () => {
    if (sliderRef?.current?.slickNext) {
      sliderRef?.current?.slickNext();
    }
  };

  return (
    <Slider ref={(slider) => (sliderRef.current = slider)} {...settings}>
      {imageArray?.map((image, index) => (
        <MediaContainer
          key={index}
          containerClasses="tw-max-h-[480px] tw-max-w-[100%] tw-mx-auto"
        >
          {image?.media_type === MEDIA_TYPES.YOUTUBE_VIDEO ? (
            <section className="flex justify-center items-center h-100 relative tw-w-full">
              {imageArray.length > 1 && (
                <>
                  <span
                    className=" absolute left-0 h3 w2 bg-black-20 flex justify-center items-center"
                    onClick={onPrevClick}
                  >
                    <img
                      src="https://cdn.dotpe.in/longtail/themes/8073865/1cy3Zqf6.webp"
                      className="img h1"
                    />
                  </span>
                  <span
                    className=" absolute right-0 h3 w2 bg-black-20 flex justify-center items-center"
                    onClick={onNextClick}
                  >
                    <img
                      src="https://cdn.dotpe.in/longtail/themes/8073865/7cs2CGfO.webp"
                      className="img h1"
                    />
                  </span>
                </>
              )}
              <iframe
                src={`https://www.youtube.com/embed/${image?.image_url?.substr(
                  -11
                )}?autoplay=${activeSlide === index ? 1 : 0}`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen={true}
                auto
                className="tw-h-full tw-w-full tw-object-contain"
              ></iframe>
            </section>
          ) : image?.media_type !== MEDIA_TYPES.VIDEO ? (
            <img
              src={image.image_url}
              alt={`image ${image.image_id}`}
              style={{ objectFit: 'contain', width: '100%', height: '100%' }}
            />
          ) : (
            <video
              src={image?.image_url || ''}
              controls
              style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            />
          )}
        </MediaContainer>
      ))}
    </Slider>
  );
};

const QuickViewDesktopImageComponent = (props) => {
  const { imageArray } = props;
  const sliderRef = useRef();
  // const [activeSlide, setActiveSlide] = useState(0);
  const [initialSlide, setInitialSlide] = useState(0);

  useEffect(() => {
    setInitialSlide(0);
    sliderRef?.current?.slickGoTo(0);
  }, [props.activeVariant]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    activeSlide: initialSlide,
    // afterChange: current => setActiveSlide(current),
    beforeChange: (current) => {
      if (imageArray[current]?.media_type === MEDIA_TYPES.YOUTUBE_VIDEO) {
        stopVideo();
      }
    },
  };

  const stopVideo = () => {
    const productVedioIframe = document.querySelector('.desktopQV-vedio > iframe');
    productVedioIframe && (productVedioIframe.src = productVedioIframe.src);
  };

  /**
   * slider prev button
   * click handler function
   */
  const onPrevClick = () => {
    if (sliderRef?.current?.slickPrev) {
      sliderRef?.current?.slickPrev();
    }
  };

  /**
   * slider next button
   * click handler function
   */
  const onNextClick = () => {
    if (sliderRef?.current?.slickNext) {
      sliderRef?.current?.slickNext();
    }
  };

  return (
    <Slider ref={sliderRef} {...settings}>
      {imageArray?.map((image, index) => (
        <MediaContainer
          key={index}
          containerClasses="tw-mx-auto tw-max-h-[480px] tw-max-w-full"
        >
          {image?.media_type === MEDIA_TYPES.YOUTUBE_VIDEO ? (
            <section className="desktopQV-vedio flex justify-center items-center h-100 relative bg-black tw-h-full tw-w-full">
              {imageArray.length > 1 && (
                <>
                  <span
                    className=" absolute left-0 h3 w2 bg-black-20 flex justify-center items-center"
                    onClick={onPrevClick}
                  >
                    <img
                      src="https://cdn.dotpe.in/longtail/themes/8073865/1cy3Zqf6.webp"
                      className="img h1"
                    />
                  </span>
                  <span
                    className=" absolute right-0 h3 w2 bg-black-20 flex justify-center items-center"
                    onClick={onNextClick}
                  >
                    <img
                      src="https://cdn.dotpe.in/longtail/themes/8073865/7cs2CGfO.webp"
                      className="img h1"
                    />
                  </span>
                </>
              )}
              <iframe
                className="tw-h-full tw-w-full tw-object-contain"
                src={`https://www.youtube.com/embed/${image?.image_url?.substr(-11)}`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen={true}
                auto
              ></iframe>
            </section>
          ) : image?.media_type !== MEDIA_TYPES.VIDEO ? (
            <img
              src={image.image_url}
              alt={`image ${image.image_id}`}
              style={{ objectFit: 'contain', width: '100%', height: '100%' }}
            />
          ) : (
            <video
              src={image?.image_url || ''}
              controls
              style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            />
          )}
        </MediaContainer>
      ))}
    </Slider>
  );
};

export { QuickViewCarouselMobile, QuickViewDesktopImageComponent };
